import { Button } from '@components/core-ui/form-elements/buttons/Button';

import { TProps } from './types/TProps';

export const PageErrorState = ({ message, actionLabel, onAction, actionDisabled = false, className }: TProps) => {
  return (
    <div
      className={[
        'flex min-h-48 flex-1 flex-col items-center justify-center gap-3 text-center text-sm text-[var(--color-text-muted)]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="alert"
    >
      <p className="m-0">{message}</p>
      {onAction ? (
        <Button disabled={actionDisabled} onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
};
